import cx from 'classnames';
import { OTPInput, REGEXP_ONLY_DIGITS, type SlotProps } from 'input-otp';

const OTPInputImpl = ({
  name,
  maxLength = 6,
  onComplete,
}: {
  name: string;
  maxLength?: number;
  onComplete: () => void;
}) => {
  return (
    <OTPInput
      name={name}
      maxLength={maxLength}
      autoComplete="one-time-code"
      inputMode="numeric"
      pattern={REGEXP_ONLY_DIGITS}
      containerClassName="group flex justify-center items-center has-[:disabled]:opacity-30"
      render={({ slots }) => (
        <div className="flex justify-center">
          {slots.slice(0, maxLength).map((slot, idx) => (
            <Slot key={idx} {...slot} />
          ))}
        </div>
      )}
      onComplete={onComplete}
    />
  );
};

function Slot(props: SlotProps) {
  return (
    <div
      className={cx(
        'relative w-10 h-14 text-[2rem]',
        'flex items-center justify-center',
        'transition-all duration-300',
        'border-border border-gray-400 border-y border-r first:border-l first:rounded-l-md last:rounded-r-md',
        'group-hover:border-gray-700 group-focus-within:border-gray-700',
        'outline outline-0 outline-gray-700',
        { 'outline-4 outline-gray-700': props.isActive },
      )}
    >
      <div className="group-has-[input[data-input-otp-placeholder-shown]]:opacity-20">
        {props.char ?? props.placeholderChar}
      </div>
      {props.hasFakeCaret && <FakeCaret />}
    </div>
  );
}

function FakeCaret() {
  return (
    <div className="absolute inset-0 flex items-center justify-center pointer-events-none animate-caret-blink">
      <div className="w-px h-8 bg-gray-950" />
    </div>
  );
}

export default OTPInputImpl;
